export const ooraInfraDatasetReducer = (state = {}, action) => {
  switch (action.type) {
    // LIST
    case "GET_OORA_INFRA_DATASET_LIST_REQUEST":
      return {
        ...state,
        loading: true,
        listLoading: true,
      };

    case "GET_OORA_INFRA_DATASET_LIST_SUCCESS":
      return {
        ...state,
        loading: false,
        listLoading: false,
        ooraInfraDatasetList: action.payload,
        listError: null,
      };

    case "GET_OORA_INFRA_DATASET_LIST_FAILED":
      return {
        ...state,
        loading: false,
        listLoading: false,
        listError: action.payload,
      };

    // SINGLE (VIEW)
    case "GET_OORA_INFRA_DATASET_REQUEST":
      return {
        ...state,
        loading: true,
        singleLoading: true,
        singleError: null,
      };

    case "GET_OORA_INFRA_DATASET_SUCCESS":
      return {
        ...state,
        loading: false,
        singleLoading: false,
        ooraInfraDataset: action.payload,
        singleError: null,
      };

    case "GET_OORA_INFRA_DATASET_FAIL":
      return {
        ...state,
        loading: false,
        singleLoading: false,
        singleError: action.payload,
      };

    // ADD
    case "ADD_OORA_INFRA_DATASET_REQUEST":
      return {
        ...state,
        loading: true,
        addLoading: true,
      };

    case "ADD_OORA_INFRA_DATASET_SUCCESS":
      return {
        ...state,
        loading: false,
        addLoading: false,
        addError: null,
      };

    case "ADD_OORA_INFRA_DATASET_FAILED":
      return {
        ...state,
        loading: false,
        addLoading: false,
        addError: action.payload,
      };

    // UPDATE
    case "UPDATE_OORA_INFRA_DATASET_REQUEST":
      return {
        ...state,
        loading: true,
        updateLoading: true,
      };

    case "UPDATE_OORA_INFRA_DATASET_SUCCESS":
      return {
        ...state,
        loading: false,
        updateLoading: false,
        updateError: null,
      };

    case "UPDATE_OORA_INFRA_DATASET_FAILED":
      return {
        ...state,
        loading: false,
        updateLoading: false,
        updateError: action.payload,
      };

    // REMOVE
    case "REMOVE_OORA_INFRA_DATASET_REQUEST":
      return {
        ...state,
        loading: true,
        removeLoading: true,
      };

    case "REMOVE_OORA_INFRA_DATASET_SUCCESS":
      return {
        ...state,
        loading: false,
        removeLoading: false,
        removeError: null,
      };

    case "REMOVE_OORA_INFRA_DATASET_FAILED":
      return {
        ...state,
        loading: false,
        removeLoading: false,
        removeError: action.payload,
      };

    case "RESET_OORA_INFRA_DATASET":
      return {
        ...state,
        ooraInfraDataset: null,
        singleError: null,
        addError: null,
        updateError: null,
        removeError: null,
        listError: null,
      };

    default:
      return state;
  }
};